import React, { useState } from "react";
import { useSpring, animated, easings } from "react-spring";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'
import "../componentsStyle.css"
import Regenerate from "../Regenerate/Regenerate";

const PdmChannels = (props) => {
    const { showMaximumChat, data, updateMessage, setIsFeedbackPop, loading ,index ,messages,sessionId,checkThumsDownFeedback  } = props


    const fadeInProps = useSpring({
        from: { opacity: Math.random() },
        to: { opacity: 1 },
        config: { duration: 1000, easing: easings.easeInOut },
        // Adjust duration and easing as needed
    });

    const formatHeader = (header) => {
      return header.replace('NUMBER', 'No.').replace(/_/g, ' ');
      };

    const renderList = (data) => {

        const list = data?.llm_response?.pdm_output;
        if (!list || list.length === 0) return null;
        const firstColumnWidth = showMaximumChat ? '35%' : '50%';
        const otherColumnWidth = showMaximumChat ? '20%' : '30%';

        const headers = Object.keys(list[0]);
        return (
            <div className="channel-list">
              <div style={{ borderRadius: '8px' }} className="list-of-channels">
                <table>
                  <thead>
                    <tr style={{ display: 'flex', marginBottom: '8px' }}>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="coloum-name"
                          style={{ width: index === 0 ? firstColumnWidth : otherColumnWidth }}
                        >
                          {formatHeader(header)} {/* Replace underscores with spaces for better readability */}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ gap: '8px', display: 'grid' }}>
                    {list.map((channel, index) => (
                      <tr key={index} style={{ display: 'flex' }}>
                        {headers.map((header, index) => (
                          <td
                            key={index}
                            className="coloum-details"
                            style={{ width: index === 0 ? firstColumnWidth : otherColumnWidth }}
                          >
                            {channel[header]}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
    };


    return (
        <div className="server-text-response-body">

            { <>
                <div className="channel-list-reponse" style={{ color: '#220046' }}>{data?.llm_response?.Text}</div>
                {renderList(data)}
                <Regenerate msg={data} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} index={index} messages={messages} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} />
            </>}

        </div>
    )
}

export default PdmChannels
